
export default {
  name: 'MinusIcon',
  props: {
    ariaHidden: {
      type: Boolean,
      default: true,
    },
    ariaLabel: {
      type: String,
      default: '',
    },
    role: {
      type: String,
      default: 'img',
    },
  },
}
